<template>
  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <el-row class="mydoc">
      <el-col class="header" style="font-weight: 900">
        【实验语言学】期刊目录
      </el-col>
      <el-col class="mybody">
        <el-row>
          <el-col
            :xl="{ span: 6 }"
            :lg="{ span: 6 }"
            :md="{ span: 6 }"
            :xs="{ span: 23 }"
            :sm="{ span: 23 }"
            ><el-table
              :data="cardData"
              stripe
              style="width: 100%"
              :show-header="false"
            >
              <el-table-column
                prop="title"
                label="标题"
                show-overflow-tooltip="true"
                border="true"
              >
                <template slot-scope="scope">
                  <a style="color: black" :href="'#' + scope.row.title">
                    {{ scope.row.title }}
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col
            :xl="{ span: 1 }"
            :lg="{ span: 1 }"
            :md="{ span: 1 }"
            :xs="{ span: 1 }"
            :sm="{ span: 1 }"
          >
            <el-divider direction="vertical"></el-divider
          ></el-col>
          <el-col
            :xl="{ span: 17 }"
            :lg="{ span: 17 }"
            :md="{ span: 17 }"
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
          >
            <el-card
              v-for="(item, index) in cardData"
              :key="index"
              shadow="hover"
              style="height: 160px; cursor: pointer"
              class="card_shadow"
              @click.native="manuscriptDetail(item)"
            >
              <div
                slot="header"
                class="clearfix"
                style="height: 10px"
                :id="item.title"
              >
                <span
                  class="new_title"
                  style="color: #006a71; font-weight: 900"
                  >{{ item.title }}</span
                >
                <el-button
                  style="float: right; padding: 3px 0; color: #096367"
                  type="text"
                  class="hidden-sm-and-down"
                  >PDF预览</el-button
                >
              </div>
              <div>
                <div style="font-size: 14px">
                  <sapn style="color: #006a71; font-weight: 900">作者:</sapn
                  >&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ item.authorInfo.map((item) => item.name).join(",") }}
                </div>
                <div style="font-size: 14px; margin-top: 10px" class="exceed">
                  <sapn style="color: #006a71; font-weight: 900">摘要:</sapn
                  >&nbsp;&nbsp;&nbsp;&nbsp;{{ item.abstracts }}
                </div>
                <div style="font-size: 14px; margin-top: 10px" class="exceed">
                  <sapn style="color: #006a71; font-weight: 900">关键词:</sapn
                  >&nbsp;&nbsp;&nbsp;&nbsp;{{ item.manuscriptKeywords }}
                </div>
              </div>
            </el-card>
            <el-dialog :visible.sync="contentDetailShow" fullscreen center>
              <div style="height: 82vh; width: 100%">
                <iframe
                  :src="
                    'https://www.exp-linguistics.net/file_preview/onlinePreview?url=' +
                    encodeURIComponent(kkFileBase64(manuscriptTitle))
                  "
                  frameborder="none"
                  width="100%"
                  height="100%"
                ></iframe>
              </div>
              <div slot="footer">
                <el-button type="primary" @click="downloadPdf(manuscriptTitle)">
                  下载
                </el-button>
              </div>
            </el-dialog>

            <br />
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 30, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-col>
</template>>

<script>
import { fuzzySearch } from "@/api/data";
export default {
  name: "manuscriptsList",
  components: {},
  data() {
    return {
      contentDetailShow: false,
      manuscriptTitle: "",
      currentPage: 1,
      pageNum: 1,
      pageSize: 10,
      pageTotal: 0,

      cardData: [],
    };
  },
  methods: {
    kkFileBase64(newManuscriptTitile) {
      return Base64.encode(
        "http://www.exp-linguistics.net/file/" + newManuscriptTitile + ".pdf"
      );
    },
    manuscriptDetail(item) {
      this.contentDetailShow = true;
      this.manuscriptTitle = item.title;
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getFuzzySearch();
    },
    getFuzzySearch() {
      fuzzySearch({
        year: this.search.year,
        period: this.search.period,
        title: this.search.title,
        authorName: this.search.name,
        authorUint: this.search.unit,
        keywords: this.search.keywords,
        manuscriptGroup: "",
        current: this.pageNum,
        size: this.pageSize,
      }).then((res) => {
        this.cardData = res.data.result.records
        this.pageTotal = res.data.result.total

        this.back()
      })
    },
    downloadPdf(name){
      window.open('http://www.exp-linguistics.net/manuscript/file/downloadPdf?fileName=' + name + '.pdf')
    }
  },
  mounted() {
    this.search = window.search == null ? this.search : window.search;
    console.log(this.search);
    this.getFuzzySearch();
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #006a71;
}
.new_title {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: clip; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行*/
  display: block;
}
.exceed {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: clip; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
.card_shadow {
  box-shadow: 1px 1px 5px rgba(9, 99, 103, 0.5);
  /*考虑浏览器兼容性*/
  -moz-box-shadow: 1px 1px 5px rgba(9, 99, 103, 0.5);
  -webkit-box-shadow: 1px 1px 5px rgba(9, 99, 103, 0.5);
  margin-bottom: 10px;
}

.el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 1080px;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
}
.el-row {
  //   background-color: white;
  margin: auto;
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 1090px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/manuscriptsList.vue